import { useParams } from "react-router";

export const getMachineTitle = (params) => {
  const { machineName } = params ? params : useParams();
  return machineName;
};

export const getUserName = (params) => {
  const { param } = params ? params : useParams();
  return param;
};

export const getTabTitle = (params) => {
  const { tab } = params ? params : useParams();

  // example: activityLogs => Activity Logs
  if (tab) {
    return tab
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  }

  return tab;
};

export const getImageName = (params) => {
  const { imageSetName } = params ? params : useParams();
  return imageSetName;
};
